
const routes = [];

export default routes;